import React, { useState } from 'react';
import { Icon, IconButton, InputAdornment, TextField, InputLabel } from '@material-ui/core';
import { useField } from 'formik';

const PasswordInput = ({ name, label, maxLength, ...otherProps }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [field, meta] = useField(name);
  const CHARACTER_LIMIT = maxLength;

  const switchType = () => setShowPassword(!showPassword);

  const PasswordFieldProps = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: 'outlined',
    size: 'small',
    autoComplete: 'new-password',
    FormHelperTextProps: { className: 'mx-4 mt-2 text-12' },
    InputProps: {
      className: 'pr-2',
      type: showPassword ? 'text' : 'password',
      endAdornment: (
        <InputAdornment position="end">
          <IconButton onClick={switchType}>
            <Icon className="text-20" color="action">
              {showPassword ? 'visibility' : 'visibility_off'}
            </Icon>
          </IconButton>
        </InputAdornment>
      )
    },
    inputProps: { maxLength },
    error: meta && meta.touched && meta.error ? true : undefined,
    helperText: (
      <div className="flex justify-between">
        <span className="mr-4">{meta.touched && meta?.error}</span>
        {meta.value?.length}/{CHARACTER_LIMIT}
      </div>
    )
  };

  return (
    <>
      <InputLabel className="mb-8 text-gray-700 font-semibold"> {label} </InputLabel>
      <TextField {...PasswordFieldProps} />
    </>
  );
};

export default PasswordInput;
